import checkLine from '@raison/static/icons/check-line.svg';
import fileCopyLine from '@raison/static/icons/file-copy-line.svg';
import React, {useState} from 'react';
import {cn} from '../../Utilities';
import InlineSvg from '../InlineSvg/InlineSvg';

export function RsnCopyIcon({
    copied,
    size: sizeProp = '4',
    color: colorProp = 'neutral-60',
}: {
    copied: boolean;
    size?: keyof typeof sizes;
    color?: keyof typeof colors;
}) {
    const size = sizes[sizeProp];
    const color = colors[colorProp];
    return (
        <div className={`${size} overflow-hidden`}>
            <div
                className={cn('flex flex-col gap-2 transition-transform duration-500 ease-in-out', {
                    'transform-none': !copied,
                    '-translate-y-6': copied,
                })}
            >
                <InlineSvg src={fileCopyLine} className={`${size} ${color}`} />
                <InlineSvg src={checkLine} className={`${size} text-success-30`} />
            </div>
        </div>
    );
}

const sizes = {
    '4': 'size-4',
    '5': 'size-5',
    '6': 'size-6',
};

const colors = {
    'neutral-60': 'text-neutral-60',
    'primary-30': 'text-primary-30',
};

export function useCopyToggle() {
    const [copied, setCopied] = useState(false);
    const onClick = () => {
        if (copied) {
            return;
        }
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };
    return [copied, onClick] as const;
}
